import React, { createContext, useContext, useRef, useState, useCallback, useEffect } from 'react';
import { useAuth } from './AuthContext';

const FeedContext = createContext();

export function useFeedContext() {
    return useContext(FeedContext);
}

export function FeedProvider({ children }) {
    const { user } = useAuth();
    // Store feed states. Key = feed identifier (e.g. "dashboard-for_you", "dashboard-lost")
    // Structure: { [key]: { posts: [], page: 1, hasMore: true, scrollY: 0, lastFetched: timestamp } }
    const feedStates = useRef({});

    // Store other UI states like active tabs
    const [uiState, setUiState] = useState({
        dashboardTab: 'for_you'
    });

    // Reset state on logout (or user change)
    useEffect(() => {
        if (!user) {
            feedStates.current = {};
            setUiState({ dashboardTab: 'for_you' });
        }
    }, [user]);

    const getFeedState = useCallback((key) => {
        return feedStates.current[key];
    }, []);

    const setFeedState = useCallback((key, state) => {
        feedStates.current[key] = { ...feedStates.current[key], ...state };
    }, []);

    const clearFeedState = useCallback((key) => {
        delete feedStates.current[key];
    }, []);

    const setDashboardTab = useCallback((tab) => {
        setUiState(prev => ({ ...prev, dashboardTab: tab }));
    }, []);

    const value = {
        feedStates: feedStates.current,
        getFeedState,
        setFeedState,
        clearFeedState,
        dashboardTab: uiState.dashboardTab,
        setDashboardTab
    };

    return (
        <FeedContext.Provider value={value}>
            {children}
        </FeedContext.Provider>
    );
}
